module.exports = __webpack_public_path__ + "img/autoentry.ccf13f0a.png";